export default __webpack_public_path__ + "static/media/wTop_3_c1.e7a8f667.jpeg";